/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseProductUploadResult } from '../../models/api-response-product-upload-result';
import { ProductUpload } from '../../models/product-upload';

export interface UploadProducts$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Array<ProductUpload>
}

export function uploadProducts(http: HttpClient, rootUrl: string, params: UploadProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProductUploadResult>> {
  const rb = new RequestBuilder(rootUrl, uploadProducts.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseProductUploadResult>;
    })
  );
}

uploadProducts.PATH = '/v1/api/products/upload';
